import * as React from 'react'

export const RadioGroupContext = React.createContext<{
  value?: unknown
  name?: string
  ref?: React.Ref<HTMLInputElement>
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
} | null>(null)
